import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface ChangeTeamDialogProps {
  isOpen: boolean;
  username: string;
  initialTeam: string;
  isUpdating: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: () => void;
  onTeamChange: (value: string) => void;
  teamValue: string;
}

const ChangeTeamDialog = ({
  isOpen,
  username,
  initialTeam,
  isUpdating,
  onOpenChange,
  onSave,
  onTeamChange,
  teamValue,
}: ChangeTeamDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className='sm:max-w-md'>
        <AlertDialogHeader>
          <AlertDialogTitle>Change Team</AlertDialogTitle>
          <AlertDialogDescription>
            Update team for user: <span className='font-semibold'>{username}</span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className='py-4'>
          <div className='space-y-4'>
            <div className='space-y-2'>
              <Label htmlFor='team'>Team Name</Label>
              <Input id='team' placeholder='Enter new team name' value={teamValue} onChange={e => onTeamChange(e.target.value)} />
            </div>
          </div>
        </div>
        <AlertDialogFooter>
          <Button variant='outline' onClick={() => onOpenChange(false)} disabled={isUpdating}>
            Cancel
          </Button>
          <Button onClick={onSave} disabled={isUpdating}>
            {isUpdating ? <Loader2 className='h-4 w-4 animate-spin mr-2' /> : null}
            Save Changes
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ChangeTeamDialog;
